import React from 'react';
import { motion } from 'framer-motion';
export function PainSection() {
  const changes = ['Te cambia el humor.', 'Te cambia la paciencia.', 'Te cambia el cuerpo.', 'Te cambia la relación con tu pareja.', 'Te cambia la forma en que ves la maternidad.'];
  return <section className="py-20 px-4 bg-[#0f182e]" data-id="element-129">
      <div className="max-w-3xl mx-auto" data-id="element-130">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="space-y-6 text-lg md:text-xl text-amber-50/90 leading-relaxed" data-id="element-131">
          <h2 className="text-3xl md:text-4xl font-serif text-cream mb-8" data-id="element-132">
            Este no es un PDF "bonito". <br data-id="element-133" />
            <span className="text-amber-400/80 italic" data-id="element-134">
              Es un plan para noches reales.
            </span>
          </h2>

          <p data-id="element-135">Si estás aquí, probablemente tu noche se parece a una de estas:</p>
          <ul className="list-disc pl-6 space-y-2 text-amber-100/80 marker:text-amber-500" data-id="element-136">
            <li data-id="element-137">Tu bebé se despierta cada 45–120 minutos</li>
            <li data-id="element-138">
              Solo se duerme con pecho/biberón/mecer y exige lo mismo en cada
              despertar
            </li>
            <li data-id="element-139">Si lo intentas "dejar", lloras tú primero</li>
            <li data-id="element-140">
              Y durante el día funcionas como puedes… pero por dentro estás
              vacía
            </li>
          </ul>

          <div className="py-8" data-id="element-141">
            <h3 className="text-2xl font-serif text-cream mb-4" data-id="element-142">
              Y lo peor no es el sueño.
            </h3>
            <p className="mb-6" data-id="element-143">
              Lo peor es lo que el sueño te está haciendo a ti:
            </p>

            <div className="space-y-3 pl-4 border-l-2 border-amber-500/30" data-id="element-144">
              {changes.map((change, index) => <motion.p key={index} initial={{
              opacity: 0,
              x: -10
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1
            }} className="text-amber-100/90" data-id="element-145">
                  {change}
                </motion.p>)}
            </div>
          </div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="py-12 text-center" data-id="element-146">
            <p className="text-lg text-amber-200/60 mb-4" data-id="element-147">
              Hay una frase que muchas mamás no se atreven a decir en voz alta:
            </p>
            <blockquote className="text-4xl md:text-5xl font-serif italic text-amber-400 leading-tight" data-id="element-148">
              "Ya no me gusto."
            </blockquote>
          </motion.div>

          <div className="bg-amber-900/20 p-8 rounded-xl border border-amber-500/20 mt-8" data-id="element-149">
            <h3 className="text-xl font-bold text-amber-400 mb-2" data-id="element-150">
              La buena noticia
            </h3>
            <p data-id="element-151">
              No necesitas volverte otra persona. Necesitas un sistema que no
              dependa de tu fuerza de voluntad a las 2am.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}